import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { moderationListSearchSchema } from '@/entities/moderation';
import {
  createModerationParamsChange,
  moderationLoaderDeps,
  moderationRouteLoader,
  requireAuthBeforeLoad,
  RestaurantsModerationPage,
} from '@/pages/moderation';

/** Restaurants moderation queue — URL is the single source of truth for status/search/date/page. */
export const Route = createFileRoute('/moderation/restaurants')({
  staticData: { permission: 'moderation.restaurants.view' },
  beforeLoad: requireAuthBeforeLoad,
  validateSearch: moderationListSearchSchema,
  loaderDeps: moderationLoaderDeps,
  loader: moderationRouteLoader('restaurants'),
  component: RestaurantsModerationRoute,
});

function RestaurantsModerationRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const onParamsChange = createModerationParamsChange(search, (options) => {
    void navigate(options);
  });

  return <RestaurantsModerationPage params={search} onParamsChange={onParamsChange} />;
}
